/** Shared semantic treatment for the approved Runner navigation and widgets. */
export const runnerTheme = {
  navy: '#343F5B',
  orange: '#F67A1A',
  green: '#25862D',
  ink: '#1B2233',
  muted: '#5A6478',
  line: '#E2E6EE',
  white: '#FFFFFF',
  group: '#EBF4FA',
  selected: '#EDF2EE',
  rail: '#3DA026',
  avatar: '#94A3A0',
  topics: {
    orders: { accent: '#343F5B', link: '#343F5B', wash: '#EBF4FA' },
    attention: { accent: '#F67A1A', link: '#9A450D', wash: '#FFF6ED' },
    customers: { accent: '#25862D', link: '#25862D', wash: '#F3FAF4' },
    earnings: { accent: '#25862D', link: '#25862D', wash: '#F3FAF4' },
    schedule: { accent: '#343F5B', link: '#343F5B', wash: '#FFFFFF' },
    account: { accent: '#343F5B', link: '#343F5B', wash: '#FFFFFF' },
    support: { accent: '#343F5B', link: '#343F5B', wash: '#FFFFFF' },
  },
} as const;

export type RunnerTopic = keyof typeof runnerTheme.topics;
